import { DisplayItem } from 'design-system';

/**
 * Unified source for identification types
 */
export const list: DisplayItem[] = [
  { Value: 'N', Text: 'Cédula' },
  { Value: 'P', Text: 'Pasaporte' },
  { Value: 'U', Text: 'DIMEX' },
];

/**
 * List of identities for Legal Person
 */
export const legalEntityList: DisplayItem[] = [
  { Value: 'J', Text: 'RUC - Persona Jurídica' },
];

/**
 * List of all identities
 */
export const fullEntityList: DisplayItem[] = [
  { Value: 'N', Text: 'Cédula' },
  { Value: 'P', Text: 'Pasaporte' },
  { Value: 'U', Text: 'DIMEX' },
  { Value: 'J', Text: 'Cédula jurídica' },
];

/**
 * List of all Labels by identities
 */
export const entityLabelList: DisplayItem[] = [
  { Value: 'N', Text: 'Número de cédula' },
  { Value: 'P', Text: 'Número de pasaporte' },
  { Value: 'U', Text: 'Número DIMEX' },
  { Value: 'J', Text: 'Número de cédula jurídica' },
];

/**
 * List of all descriptions by identities
 */
export const entityDescriptionList: DisplayItem[] = [
  {
    Value: 'N',
    Text: 'Sin espacios ni guiones (ej. 888888888), tal como aparece en tu identificación.',
  },
  {
    Value: 'P',
    Text: 'Sin espacios ni guiones (ej. 888888888), tal como aparece en tu identificación.',
  },
  {
    Value: 'U',
    Text: 'Sin espacios ni guiones (ej. 888888888888), tal como aparece en tu identificación.',
  },
  { Value: 'J', Text: 'Sin espacios ni guiones (ej. 8888888888).' },
];

export const defaultValue = 'N';
